import { render, staticRenderFns } from "./AllowancesPlanEdit.vue?vue&type=template&id=036ce9e1&scoped=true&"
import script from "./AllowancesPlanEdit.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ce9e1",
  null
  
)

export default component.exports